/**
 * Pure parsing + shaping helpers for the `lake_hybrid_search` tool result. No
 * React, no IO — the controller (LakeHybridSearchToolUI) and the presentational
 * view both consume these.
 */

export interface LakeHybridSearchArgs {
  query: string
  top_k?: number
  file_type?: string | null
  document_type?: string | null
  date_min?: number | null
  date_max?: number | null
}

export interface LakeDocumentHit {
  document_id: string
  filename: string | null
  label: string | null
  storage_path: string | null
  file_type: string | null
  document_type: string | null
  snippet: string | null
  score: number
}

export interface LakeChunkHit {
  document_id: string | null
  chunk_id: string | null
  filename: string | null
  label: string | null
  storage_path: string | null
  page: number | string | null
  snippet: string | null
  score: number
}

export interface LakeHybridSearchResult {
  document_hits: LakeDocumentHit[]
  chunk_hits: LakeChunkHit[]
  total_documents: number
  total_chunks: number
  error?: string
}

export function parseResult(
  raw: LakeHybridSearchResult | string | undefined
): LakeHybridSearchResult | null {
  if (raw == null) return null
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as LakeHybridSearchResult
    } catch {
      return { document_hits: [], chunk_hits: [], total_documents: 0, total_chunks: 0, error: raw }
    }
  }
  return raw
}

export function scoreColor(score: number): string {
  if (score >= 0.7) return 'bg-success/20 text-success-foreground'
  if (score >= 0.4) return 'bg-accent text-accent-foreground'
  return 'bg-muted text-muted-foreground'
}

export function normalizeDisplayFilename(filename: string | null | undefined): string {
  if (!filename) return 'Document'
  const m = filename.match(/^([a-f0-9-]{12,})_(.+)$/i)
  return m?.[2] ?? filename
}
